import UnsavedChangesContext from 'contexts/UnsavedChangesContext';
import { useContext } from 'react';

const useUnsavedChanges = () => {
  return useContext(UnsavedChangesContext);
}

export default useUnsavedChanges;